<template>
    <div>
        <v-row>
            <v-col  class="">
                <v-row align="center">
                    <v-col col="5">
                        <v-select
                            :items="planks"
                            :label="$t('steps.materials.select.planks')"
                            item-text="name"
                            item-value="item_id"
                            v-model="plank"
                            class="mr-2"
                        >
                            <template slot="selection" slot-scope="data">
                            <v-icon :color="data.item.color">mdi-brightness-1</v-icon>
                            {{ data.item.name }}
                            </template>
                            <template slot="item" slot-scope="data">
                            <v-icon :color="data.item.color">mdi-brightness-1</v-icon>
                            {{ data.item.name }}
                            </template>
                        </v-select>
                    </v-col>
                    <v-btn
                        @click="pushItemToOffer(plank)"
                        class="mb-2"
                        color="primary"
                        dark
                        >{{ $t("base.add") }}
                    </v-btn>
                </v-row>
                <v-row align="center">
                    <v-col col="5">
                        <v-select
                        :items="elevations"
                        :label="$t('steps.materials.select.elevation')"
                        item-text="description"
                        item-value="item_id"
                        v-model="elevation"
                        class="mr-2"
                        >
                        <template slot="selection" slot-scope="data">
                            <v-icon :color="data.item.color">mdi-brightness-1</v-icon>
                            {{ data.item.name }}
                            </template>
                            <template slot="item" slot-scope="data">
                            <v-icon :color="data.item.color">mdi-brightness-1</v-icon>
                            {{ data.item.name }}
                            </template>
                    </v-select>
                    </v-col>


                    <v-btn
                        @click="pushItemToOffer(elevation)"
                        class="mb-2"
                        color="primary"
                        dark
                        >{{ $t("base.add") }}
                    </v-btn>
                </v-row>
                <v-row align="center">
                    <v-col col="5">
                        <v-select
                            :items="stairs"
                            :label="$t('steps.materials.select.stair')"
                            item-text="description"
                            item-value="id"
                            v-model="stair"
                            class="mr-2"
                        ></v-select>
                    </v-col>
                        <v-btn
                        @click="pushItemToOffer(stair)"
                        class="mb-2"
                        color="primary"
                        dark
                        >{{ $t("base.add") }}
                        </v-btn>
                </v-row>
                <v-row align="center">
                    <v-col col="5">
                        <v-select
                            :items="joists"
                            :label="$t('steps.materials.select.joist')"
                            item-text="name"
                            item-value="item_id"
                            v-model="joist"
                            class="mr-2"
                        ></v-select>
                    </v-col>
                    <v-btn
                        @click="pushItemToOffer(joist)"
                        class="mb-2"
                        color="primary"
                        dark
                        >{{ $t("base.add") }}
                    </v-btn>
                </v-row>
            </v-col>
            <v-col class="">
                <v-row align="center">
                    <v-col col="5">
                    <v-select
                        :items="slats"
                        :label="$t('steps.materials.select.slats')"
                        item-text="name"
                        item-value="item_id"
                        v-model="slat"
                        class="mr-2"
                    ></v-select>
                    </v-col>
                        <v-btn
                            @click="pushItemToOffer(slat)"
                            class="mb-2"
                            color="primary"
                            dark
                            >{{ $t("base.add") }}
                        </v-btn>
                </v-row>
                <v-row align="center">
                    <v-col col="5">
                        <v-select
                            :items="elevationSlats"
                            :label="$t('steps.materials.select.corner')"
                            item-text="name"
                            item-value="item_id"
                            v-model="corner"
                            class="mr-2"
                        ></v-select>
                    </v-col>
                        <v-btn
                            @click="pushItemToOffer(corner)"
                            class="mb-2"
                            color="primary"
                            dark
                            >{{ $t("base.add") }}
                        </v-btn>
                </v-row>
                <v-row align="center">
                    <v-col col="5">
                        <v-select
                            :items="additionals"
                            :label="$t('steps.materials.select.additionals')"
                            item-text="description"
                            item-value="id"
                            v-model="additional"
                            class="mr-2"
                        ></v-select>
                    </v-col>
                    <v-btn
                        @click="pushItemToOffer(additional)"
                        class="mb-2"
                        color="primary"
                        dark
                        >{{ $t("base.add") }}
                    </v-btn>
                </v-row>
                <v-row align="center">
                    <v-col col="5">
                        <v-select
                            :items="complementary"
                            :label="$t('steps.materials.select.complementary')"
                            :item-text="'description.' + $locale"
                            item-value="id"
                            v-model="addedItem"
                            class="mr-2"
                        ></v-select>
                    </v-col>
                        <v-btn
                        @click="pushComplementary"
                        class="mb-2"
                        color="primary"
                        dark
                        >{{ $t("base.add") }}
                        </v-btn>
                </v-row>
            </v-col>
        </v-row>
    <v-snackbar v-model="snack" :timeout="1500" :color="snackColor">
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
      </template>
    </v-snackbar>
    </div>
</template>

<script>
import units from "@/helpers/units";
import ItemType from "@/helpers/ItemType";
import discountTypes from "@/helpers/discountTypes";

export default {
  name: "MaterialSelect",
  props: {
    edit: {type: Boolean, default: false}
  },
  data() {
    return {
        editedIndex: -1,
        dialog: false,
        editedItem: { unit: null },
        addedItem: null,
        plank: {},
        joist: {},
        slat: {},
        additional: {},
        stair: {},
        elevation: {},
        corner: {},
        snack: false,
        snackColor: "",
        snackText: "",
    };
  },
  mounted() {
    this.loading = true
        this.$store.dispatch('prepareManualMaterials', true)
            .then(() => {
                this.loading = false
            })
            .catch(() => {
                this.loading = false;
            });
  },

  computed: {
    complementary() {
      return this.$store.getters.items(ItemType.complementary.id);
    },
    joists() {
      return this.$store.state.manualMaterials.joists;
    },
    planks() {
      return this.$store.getters.terracePlanks;
    },
    slats() {
      return this.$store.getters.terraceSlats;
    },
    additionals() {
      return this.$store.state.manualMaterials.additionals;
    },
    stairs() {
      return this.$store.getters.stairPlanks;
    },
    elevations() {
      return this.$store.getters.elevationPlanks;
    },
    units() {
      return units.filter((unit) => unit.id !== 4);
    },
    discountTypes() {
      return discountTypes;
    },
    currentStep(){
        return this.$store.state.currentStep;
    },
    elevationSlats() {
      return this.$store.getters.elevationSlats;
    },
  },
  methods: {
    pushComplementary() {
      this.editedIndex = -1;
      let complementaryItem = this.complementary.find(
        (item) => item.id == this.addedItem
      );
      this.editedItem = {
        product: complementaryItem.description,
        price: complementaryItem.price,
        tax: complementaryItem.tax,
        unit: this.units.find((unit) => unit.id == complementaryItem.unit),
        amount: 1,
        discountType: this.discountTypes[0],
        discount: 0,
        total: parseFloat(complementaryItem.price),
        obligatory: false,
        item_id: complementaryItem.id,
      };
      this.save();
    },
    pushItemToOffer(id) {
      this.editedIndex = -1;
      let searchItem = this.$store.state.items.find((item) => item.id == id);
      this.editedItem = {
        id: searchItem.id,
        item_id: searchItem.id,
        product: searchItem.description,
        price: searchItem.price,
        tax: searchItem.tax,
        unit: this.units.find((unit) => unit.id == searchItem.unit),
        amount: 1,
        discountType: this.discountTypes[0],
        discount: 0,
        total: parseFloat(searchItem.price),
        obligatory: false,
      };
      this.save();
    },
    save(){
        this.$emit('save');

        if (this.editedIndex > -1) {
        this.$store.commit("editOfferItem", {
          index: this.editedIndex,
          data: this.editedItem,
        });
      } else {
        this.$store.commit("addOfferItem", {
          data: this.editedItem,
        });
      }
      this.refreshEditedItem();
      this.dialogsave();
      this.close();
    },
    close() {
      this.dialog = false;
    },
    refreshEditedItem() {
      this.editedIndex = -1;
      this.editedItem = {
        product: { pl: "", en: "" },
        price: 0,
        tax: 23,
        unit: this.units[0],
        amount: 1,
        discountType: this.discountTypes[0],
        discount: 0,
        total: 0,
        obligatory: false,
      };
    },
    dialogsave() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Dane zapisane";
    },
    dialogcancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Anulowano";
    },
    dialogopen(item) {
      this.editedIndex = this.offerItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Wpisz dane";
    },
  },
  watch:{
    // currentStep(){
    //         if(this.currentStep == 4){
    //             this.$store.dispatch('prepareMaterials', true)
    //     }
    // }
  }
};
</script>

<style scoped>
</style>
